import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";

var WithPromise = /*#__PURE__*/function () {
  function WithPromise() {
    _classCallCheck(this, WithPromise);

    this.updateFinished();
  }

  _createClass(WithPromise, [{
    key: "finished",
    get: function get() {
      return this._finished;
    }
  }, {
    key: "updateFinished",
    value: function updateFinished() {
      var _this = this;

      this._finished = new Promise(function (resolve) {
        _this.resolve = resolve;
      });
    }
  }, {
    key: "notifyFinished",
    value: function notifyFinished() {
      this.resolve();
    }
    /**
     * Allows the animation to be awaited.
     *
     * @deprecated Use `finished` instead.
     */

  }, {
    key: "then",
    value: function then(onResolve, onReject) {
      return this.finished.then(onResolve, onReject);
    }
  }]);

  return WithPromise;
}();

export { WithPromise };